import { create } from 'zustand';

import { ICalculatorState, ISharedCalculatorData, ISharedCalculatorState, TCalculatorMode } from '@src/types';

const DEFAULT_SHARED_CALCULATOR_DATA: ISharedCalculatorData = {
  isOpen: false,
  isSharedByMe: false,
  owner: null,
  settings: null,
};

const DEFAULT_SHARED_CALCULATOR_STATE: ISharedCalculatorState = {
  expression: '',
  result: '',
  error: null,
};

interface ICalculatorStore {
  isPersonalCalculatorVisible: boolean;
  setIsPersonalCalculatorVisible: (show: boolean) => void;

  sharedCalculatorData: ISharedCalculatorData;
  setSharedCalculatorData: (calculator: ISharedCalculatorData) => void;
  resetSharedCalculatorData: () => void;

  sharedCalculatorState: ISharedCalculatorState;
  setSharedCalculatorState: (state: ISharedCalculatorState) => void;
  resetSharedCalculatorState: () => void;

  selectedCalculatorMode: TCalculatorMode;
  setSelectedCalculatorMode: (mode: TCalculatorMode) => void;

  calculatorState: ICalculatorState;
  setCalculatorState: (partial: Partial<ICalculatorState>) => void;
}

export const useCalculatorStore = create<ICalculatorStore>((set) => ({
  isPersonalCalculatorVisible: false,
  setIsPersonalCalculatorVisible: (isPersonalCalculatorVisible) => set({ isPersonalCalculatorVisible }),

  sharedCalculatorData: DEFAULT_SHARED_CALCULATOR_DATA,
  setSharedCalculatorData: (sharedCalculatorData) => set({ sharedCalculatorData }),
  resetSharedCalculatorData: () =>
    set({
      sharedCalculatorData: DEFAULT_SHARED_CALCULATOR_DATA,
      sharedCalculatorState: DEFAULT_SHARED_CALCULATOR_STATE,
    }),

  sharedCalculatorState: DEFAULT_SHARED_CALCULATOR_STATE,
  setSharedCalculatorState: (sharedCalculatorState) => set({ sharedCalculatorState }),
  resetSharedCalculatorState: () => set({ sharedCalculatorState: DEFAULT_SHARED_CALCULATOR_STATE }),

  selectedCalculatorMode: 'basic',
  setSelectedCalculatorMode: (selectedCalculatorMode) => set({ selectedCalculatorMode }),

  calculatorState: {
    result: '0',
    expression: null,
  },
  setCalculatorState: (partial) =>
    set((state) => ({
      calculatorState: { ...state.calculatorState, ...partial },
    })),
}));
